import { memo as Memo, useMemo } from 'react';

//* HOC's
import { withLanguageContext, withUIContext, withDataContext } from 'context';

//* Helpers
import { config } from 'helpers';

//* Components
import Weather from './Weather';
import Subscribe from './Subscribe';
import Logo from 'components/common/Logo';
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Image from 'components/common/Image';
import Button from 'components/common/Button';
import Container from 'components/common/Container';
import CustomLink from 'components/common/CustomLink';
import LanguageSwitcher from 'components/common/LanguageSwitcher';

//* Style
import FooterStyle from './style';

const AppFooter = Memo(({ global, selectedLang, winWidth }) => {
	//! Global Data
	const globalData = useMemo(() => global?.[selectedLang], [global, selectedLang]);

	//! Store footer links
	const storeFooterLinks = useMemo(() => {
		return globalData?.socials
			? Object.keys(globalData.socials).map((social) => {
					return globalData.socials[social] ? (
						<a
							key={social}
							target={'_blank'}
							aria-label={social}
							className={'socials-item'}
							rel={'noopener noreferrer'}
							href={globalData.socials?.[social]}
						>
							<Icon
								name={social}
								className={'social-icon'}
							/>
						</a>
					) : null;
			  })
			: null;
	}, [globalData?.socials, winWidth]);

	return (
		<FooterStyle className='secondaryColor4-bg'>
			<Container>
				<div className='footer-content-wrap'>
					<div className='subscribe-block'>
						<Container
							row
							full
						>
							{winWidth >= 1024 ? (
								<>
									<div className='col-4 col-dxs-6'>
										<Subscribe />

										{winWidth >= 1440 ? (
											<div className={'subscribe-block-image'}>
												<Image src={'/images/footer/blazonArm.svg'} />
											</div>
										) : null}
									</div>

									{winWidth >= 1440 && <div className='col-1 offset' />}

									<div className='col-4 col-dxs-6'>
										<div className='footer-center-wrapper'>
											<div className='ft-center-item col-title'>
												<Text
													className={'pS font-ping-bolder ft-col-50'}
													text={'visitOur'}
												/>

												<Text
													className={'pS font-ping-bolder ft-col-50'}
													text={'followUs'}
												/>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.events.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'events'}
														/>
													</CustomLink>
												</div>

												<div className='subscribe-block-socials ft-col-50'>{storeFooterLinks}</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.experience.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'experiences'}
														/>
													</CustomLink>
												</div>

												<div className={'ft-col-50'}>
													<CustomLink
														url={`https://www.instagram.com/armenia.travel/`}
														target={'_blank'}
														className={'hidden-track-link'}
													>
														<Text
															className={'pS font-ping-bolder subscribe-block-hashtag'}
															text={'#TheHiddenTrack'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.articles.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'blog'}
														/>
													</CustomLink>
												</div>

												<div className='ft-col-50'>
													<Button
														type={'oval'}
														text={'mediaLibrary'}
														className={'media-library-button'}
														url={config.routes.mediaLibrary.path}
													/>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link last'}
														url={config.routes.faq.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'faq'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.privacyPolicy.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'privacyPolicy'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.contact.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'contactUs'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link last'}
														url={config.routes.newsRooms.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'newsRoom'}
														/>
													</CustomLink>
												</div>
											</div>
										</div>
									</div>

									{winWidth >= 1440 ? <Weather colClass={'col-3'} /> : null}

									{winWidth >= 1024 && winWidth < 1440 ? (
										<div className='sb-center-block col-dxs-12'>
											<div className={'subscribe-block-image'}>
												<Image src={'/images/footer/blazonArm.svg'} />
											</div>

											<Weather />
										</div>
									) : null}
								</>
							) : winWidth >= 768 && winWidth < 1024 ? (
								<>
									<div className='col-ts-6'>
										<Subscribe />

										<div className={'subscribe-block-image'}>
											<Image src={'/images/footer/blazonArm.svg'} />
										</div>

										<Weather />
									</div>

									<div className='col-ts-2 offset' />

									<div className='col-ts-4'>
										<div className='ft-tablet-right-top'>
											<Text
												className={'pS font-ping-bolder ft-col-50'}
												text={'visitOur'}
											/>

											<CustomLink
												className={'visit-link'}
												url={config.routes.events.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'events'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.experience.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'experiences'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.articles.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'blog'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.faq.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'faq'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.privacyPolicy.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'privacyPolicy'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.contact.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'contactUs'}
												/>
											</CustomLink>

											<CustomLink
												className={'visit-link'}
												url={config.routes.newsRooms.path}
											>
												<Text
													className={'pS font-ping-regular'}
													text={'newsRoom'}
												/>
											</CustomLink>

											<Button
												type={'oval'}
												text={'mediaLibrary'}
												className={'media-library-button'}
												url={config.routes.mediaLibrary.path}
											/>
										</div>

										<div className='ft-tablet-right-bottom'>
											<Text
												className={'pS font-ping-bolder'}
												text={'followUs'}
											/>

											<div className='subscribe-block-socials'>{storeFooterLinks}</div>

											<CustomLink
												url={`https://www.instagram.com/armenia.travel/`}
												target={'_blank'}
												className={'hidden-track-link'}
											>
												<Text
													className={'pS font-ping-bolder subscribe-block-hashtag'}
													text={'#TheHiddenTrack'}
												/>
											</CustomLink>
										</div>
									</div>
								</>
							) : winWidth < 768 ? (
								<>
									<Subscribe colClass={'col-m-12'} />

									<div className='col-m-12'>
										<div className='footer-center-wrapper'>
											<div className='ft-center-item col-title'>
												<Text
													className={'pS font-ping-bolder ft-col-50'}
													text={'visitOur'}
												/>

												<Text
													className={'pS font-ping-bolder ft-col-50'}
													text={'followUs'}
												/>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.events.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'events'}
														/>
													</CustomLink>
												</div>

												<div className='subscribe-block-socials ft-col-50'>{storeFooterLinks}</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.experience.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'experiences'}
														/>
													</CustomLink>
												</div>
												<div className='ft-col-50'>
													<CustomLink
														url={`https://www.instagram.com/armenia.travel/`}
														target={'_blank'}
														className={'hidden-track-link'}
													>
														<Text
															className={'pS font-ping-bolder subscribe-block-hashtag'}
															text={'#TheHiddenTrack'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.articles.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'blog'}
														/>
													</CustomLink>
												</div>

												<div className='ft-col-50'>
													<Button
														type={'oval'}
														text={'mediaLibrary'}
														className={'media-library-button'}
														url={config.routes.mediaLibrary.path}
													/>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link last'}
														url={config.routes.faq.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'faq'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.privacyPolicy.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'privacyPolicy'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item col-title'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.contact.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'contactUs'}
														/>
													</CustomLink>
												</div>
											</div>

											<div className='ft-center-item'>
												<div className='ft-col-50'>
													<CustomLink
														className={'visit-link'}
														url={config.routes.newsRooms.path}
													>
														<Text
															className={'pS font-ping-regular'}
															text={'newsRoom'}
														/>
													</CustomLink>
												</div>
											</div>
										</div>
									</div>

									<div className='col-m-12'>
										<div className={'subscribe-block-image'}>
											<Image src={'/images/footer/blazonArm.svg'} />
										</div>

										<Weather />
									</div>
								</>
							) : null}
						</Container>
					</div>
				</div>

				<div className='line' />

				<div className='lower-footer'>
					<div className='lower-footer-text-content-wrap'>
						<div className='copyright-wrap'>
							<Text
								text={`© ${new Date().getFullYear()}`}
								className='pXS primaryColor1 font-helvetica'
							/>
							&nbsp;
							<Text
								text={'copyrightText'}
								className='pXS primaryColor1 font-helvetica'
							/>
						</div>

						<div className='made-by-wrap'>
							<Text
								text={`madeBy`}
								className='pXS primaryColor1 font-helvetica'
							/>
							&nbsp;
							<a
								href='https://conceptstudio.com'
								rel='noopener noreferrer'
								target={'_blank'}
							>
								<Text
									text={`Concept Studio`}
									className='underline primaryColor1 font-helvetica pXS'
								/>
							</a>
						</div>
						<LanguageSwitcher type={'footer'} />
					</div>

					<Logo type={'footer'} />
				</div>
			</Container>
		</FooterStyle>
	);
});

export default withLanguageContext(withUIContext(withDataContext(AppFooter, ['global']), ['winWidth']), ['selectedLang']);
